import type { Price } from '@backmarket/core-types/Price'
import type { PriceNumber } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'

export function normalizePrice(price: Price | PriceNumber): Price {
  return {
    amount: price.amount.toString(),
    currency: price.currency,
  }
}
